module.exports = __webpack_public_path__ + "img/yachthouse_localizacao.51d01eb6.jpg";